import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  routes: [],
  loading: false,
  error: null,
};

const routeSlice = createSlice({
  name: "routes",
  initialState,
  reducers: {
    setRoutes: (state, action) => {
      state.routes = action.payload;
      state.loading = false;
      state.error = null;
    },
    
    setRouteLoading: (state, action) => {
      state.loading = action.payload;
    },
    setRouteError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearRouteError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setRoutes,
  setRouteLoading,
  setRouteError,
  clearRouteError,
} = routeSlice.actions;

// Selectors - Direct access to routes state
export const selectRoutes = (state) => state.routes?.routes || [];
export const selectRouteLoading = (state) => state.routes?.loading || false;
export const selectRouteError = (state) => state.routes?.error || null;

export default routeSlice.reducer;
